import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-vs-others',
  templateUrl: './vs-others.html',
  styleUrls: ['./vs-others.scss']
})
export class VsOthersComponent implements OnInit {
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 

  constructor() { }

  ngOnInit(): void {
  }

}
